const sharedFunctions = require('./dataGridPagerSharedFunctions');

module.exports = function (args) {
  let DCLG = window.DCLG || {};

  let $pagerElem = $('<div class="pager-items"/>');
  let $pagerElemControl = $('<div class="pager-controls"/>');
  let $next = sharedFunctions.getPagerButton("Next", args.pageIndex, args.pageCount);
  let $prev = sharedFunctions.getPagerButton("Prev", args.pageIndex, args.pageCount);
  let $pager = sharedFunctions.getPager(args.pageIndex, args.pageCount);

  let firstDisplayedItem = 0;
  let lastDisplayedItem = 0;
  buildAndSetItemRange(args.pageIndex, args.pageSize, args.itemCount);

  // To fetch the most recent values:
  if (args.pageCount > 0) {
    $pagerElemControl.append($prev).append($pager).append($next);
    $pagerElem.append($pagerElemControl);
  }

  if ($('.pagination-summary-items').length) {
    $('.pagination-summary-items').text(args.pageCount ? 'Displaying ' + firstDisplayedItem + ' to ' + lastDisplayedItem + ' of ' + args.itemCount : '');
  } else {
    let $summary = getPageSummary(firstDisplayedItem, lastDisplayedItem, args.itemCount);
    $pagerElem.append($summary);
  }

  DCLG.pageCount = args.pageCount;
  window.DCLG = DCLG;

  return $pagerElem;

  function getPageSummary(currentFirstItem, currentLastItem, itemCount) {
    let $pagerSummary = $('<div class="pager-summary-items"/>');
    let $records =
        "Displaying " +
        '<span class="pager-start">' +
        currentFirstItem +
        " to " +
        currentLastItem +
        "</span>" +
        " of " +
        '<span class="pager-total">' +
        itemCount +
        "</span> ";

    return $pagerSummary.append($records);
  }

  function buildAndSetItemRange(currentPage, pageSize, itemCount) {
      firstDisplayedItem = ((currentPage - 1) * pageSize) + 1;
      lastDisplayedItem = Math.min(currentPage * pageSize, itemCount);
  }
}